/* REAL YOU：所有關鍵字都必須符合商品名稱。
   最後一個關鍵字允許前綴匹配，例如 24 可找到 2424。 */

const REALYOU_TITLE_SEARCH = {
  words(value) {
    return [
      ...new Set(
        String(value || '')
          .normalize('NFKC')
          .replace(/[丨｜|]/g, ' ')
          .match(/[\p{L}\p{N}]+/gu) || []
      )
    ];
  },

  query(value) {
    const words = this.words(value);

    return words
      .map((word, index) => {
        const suffix = index === words.length - 1 ? '*' : '';
        return 'title:' + word + suffix;
      })
      .join(' AND ');
  },

  submit(event) {
    const form = event.currentTarget;
    const input = form.querySelector(
      'input[type="search"][name="q"]'
    );

    if (!input || form.getAttribute('role') !== 'search') return;

    event.preventDefault();

    const query = REALYOU_TITLE_SEARCH.query(input.value);

    if (!query) {
      input.focus();
      return;
    }

    const url = new URL(form.action, window.location.href);
    url.search = '';

    url.searchParams.set('q', query);
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[prefix]', 'none');
    url.searchParams.set('sort_by', 'price-ascending');

    const preview = new URL(
      window.location.href
    ).searchParams.get('preview_theme_id');

    if (preview) {
      url.searchParams.set('preview_theme_id', preview);
    }

    window.location.assign(url.toString());
  }
};

class SearchForm extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      if (
        this.input.form &&
        !this.input.form.dataset.ryTitleSearchReady
      ) {
        this.input.form.dataset.ryTitleSearchReady = 'true';

        this.input.form.addEventListener(
          'submit',
          REALYOU_TITLE_SEARCH.submit
        );
      }

      this.input.form.addEventListener(
        'reset',
        this.onFormReset.bind(this)
      );

      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden =
      this.resetButton.classList.contains('hidden');

    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove('hidden');
    } else if (
      this.input.value.length === 0 &&
      !resetIsHidden
    ) {
      this.resetButton.classList.add('hidden');
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    event.preventDefault();

    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define('search-form', SearchForm);